import * as Joi from 'joi';
import { BackgroundFormatTypes, ConditionalFormattingComparisonTypes, Operators, TableContentDensity, TableTheme, TableVizPropVersion, } from '../../types/prism';
class TableClientStateV1Class {
}
const FontPropertiesSchema = Joi.object({
    __typename: Joi.string().valid('FontAttrs'),
    color: Joi.string().allow(null),
    bold: Joi.boolean().allow(null),
    italic: Joi.boolean().allow(null),
    strikeThrough: Joi.boolean().allow(null),
    underline: Joi.boolean().allow(null),
});
const ConditionalFormatConfigSchemaV1 = Joi.object({
    __typename: Joi.string().valid('ConditionalMetric'),
    operator: Joi.string().valid(...Object.values(Operators)),
    rangeValues: Joi.object({
        __typename: Joi.string().valid('Range'),
        min: Joi.number().unsafe(),
        max: Joi.number().unsafe(),
    }).allow(null),
    value: Joi.string().allow(null, ''),
    plotAsBand: Joi.boolean().allow(null),
    fontProperties: FontPropertiesSchema.allow(null),
    backgroundFormatType: Joi.string()
        .valid(...Object.values(BackgroundFormatTypes))
        .allow(null),
    gradientBackgroundAttrs: Joi.object({
        __typename: Joi.string().valid('GradientBackgroundAttrs'),
        backgroundFormatRange: Joi.array()
            .items(Joi.number())
            .allow(null),
        backgroundFormatMidpoint: Joi.number()
            .unsafe()
            .allow(null),
        colors: Joi.array().items(Joi.string()),
    }).allow(null),
    solidBackgroundAttrs: Joi.object({
        __typename: Joi.string().valid('SolidBackgroundAttrs'),
        color: Joi.string().allow(null),
    }).allow(null),
    comparisonType: Joi.string()
        .valid(...Object.values(ConditionalFormattingComparisonTypes))
        .allow(null),
    lhsColumnId: Joi.string().allow(null),
    rhsColumnId: Joi.string().allow(null),
    comparisonParameterId: Joi.string().allow(null),
    isHighlightRow: Joi.boolean().allow(null),
});
const TableColumnPropertiesSchemaV1 = Joi.object({
    __typename: Joi.string().valid('TableVizColumnProperties'),
    wrapColumnText: Joi.boolean().allow(null),
    conditionalFormatting: Joi.object({
        __typename: Joi.string().valid('ConditionalFormatting'),
        rows: Joi.array().items(ConditionalFormatConfigSchemaV1),
    }).allow(null),
    isHidden: Joi.boolean().allow(null),
});
const WidthStateMapSchema = Joi.object({
    __typename: Joi.string().valid('WidthStateMap'),
    columnId: Joi.string().allow(null),
    width: Joi.number().allow(null),
});
const TableClientStateV1Schema = Joi.object({
    __typename: Joi.string().valid('TableVizProps'),
    columnProperties: Joi.array().items(Joi.object({
        __typename: Joi.string().valid('TableColumnPropertyMap'),
        columnId: Joi.string(),
        columnProperty: TableColumnPropertiesSchemaV1,
    })),
    density: Joi.string()
        .valid(...Object.values(TableContentDensity))
        .allow(null),
    theme: Joi.string()
        .valid(...Object.values(TableTheme))
        .allow(null),
    showGridSummary: Joi.boolean().allow(null),
    wrapTableHeader: Joi.boolean().allow(null),
    showTableFooter: Joi.boolean().allow(null),
    orderedColumnIds: Joi.array().items(Joi.string()),
    widthState: Joi.array().items(WidthStateMapSchema),
    tableVizPropVersion: Joi.string()
        .valid(TableVizPropVersion.V1)
        .required(),
});
export { TableClientStateV1Class, TableClientStateV1Schema, ConditionalFormatConfigSchemaV1, };
//# sourceMappingURL=v1.js.map